import { SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300 } from '@oneaudi/unified-web-alpha-common';
import { Card } from '@oneaudi/unified-web-alpha-components';
import styled from 'styled-components';
import { breakPoints } from '~/styles/break-points';

export const StyledTriggerItemCard = styled(Card)`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_200};
	${breakPoints({
		'768': `flex-direction: row-reverse; justify-content: space-between;`,
	})};

	.content-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: ${SYS_SPACE_FIXED_200};
	}

	.button-content {
		display: flex;
		flex-direction: column;
		gap: ${SYS_SPACE_FIXED_200};
		text-align: start;
	}
`;

export const StyledConflictItem = styled(Card)`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_200};
	${breakPoints({
		'768': `flex-direction: row-reverse; justify-content: space-between;`,
	})};
`;

export const StyledImageOrButton = styled.div<{ autoHeight: boolean }>`
	position: relative;
	width: 100%;
	aspect-ratio: 16 / 9;
	flex-shrink: 0;

	${breakPoints({
		'768': `
			height: ${({ autoHeight }: { autoHeight?: boolean }) => (autoHeight ? 'auto' : 'full')};
			width: 213px;
			margin-left: auto;
		`,
	})};

	> img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.img-contain {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.img-cover {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

export const StyledItemInfo = styled.div`
	display: flex;

	button {
		align-self: flex-start;
	}

	.content-container {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: ${SYS_SPACE_FIXED_300};
	}

	.clickable-content {
		display: flex;
		flex-direction: column;
		gap: ${SYS_SPACE_FIXED_150};
		text-align: start;
	}

	.item-name {
		color: ${(props) => props.theme.sys.color.text.headline.default};
	}
`;

export const StyledLoadingOverlay = styled.div`
	position: absolute;
	inset: 0;
	display: grid;
	place-items: center;
	background-color: rgba(255, 255, 255, 0.5);
`;
